import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M12.576 16.064l7.616 7.104a1.15 1.15 0 010 1.632 1.276 1.276 0 01-1.729 0l.001.001-9.312-8.736 9.344-8.864c.224-.215.528-.347.864-.347s.64.132.864.348a1.15 1.15 0 010 1.632z" /></svg>;